import './accountLayout.scss';

import React from 'react';
import PropTypes from 'prop-types';
import { Badge, Container } from 'components/base';

import useUserContext from '../../context/user';

// Page frame for the account section: "My Account" eyebrow, the section name
// as the page H1 and the content on full container width. Navigation between
// sections lives in the header AccountMenu. PRO accounts (`pro` from
// /users/me, granted by an operator) get a badge next to the title.
const AccountLayout = (props) => {
  const userContext = useUserContext();

  return (
    <Container>
      <header className="account-layout-header">
        <p className="account-layout-eyebrow">{props.eyebrow}</p>
        <div className="account-layout-heading">
          <h1 className="account-layout-title">{props.title}</h1>
          {userContext.data.pro && (
            <Badge type="primary" pill className="account-layout-badge">
              PRO
            </Badge>
          )}
        </div>
      </header>
      {props.children}
    </Container>
  );
};

AccountLayout.propTypes = {
  title: PropTypes.string.isRequired,
  eyebrow: PropTypes.string,
  children: PropTypes.node,
};

AccountLayout.defaultProps = {
  eyebrow: 'My Account',
};

export default AccountLayout;
